type MapNavigationStartListener = () => void;

const listeners = new Set<MapNavigationStartListener>();

/** Subscribes to the start of map navigation (pan/zoom). Returns an unsubscribe function. */
export function onMapNavigationStart(listener: MapNavigationStartListener): () => void {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
}

export function notifyMapNavigationStarted(): void {
    for (const listener of [...listeners]) {
        listener();
    }
}
